<template>
  <el-row style=" position: unset; margin-bottom: 30px;">
    <div>
      <div class="step-contract hide-line">
        <a @click="showContractContainer('general')">
          <el-button :type="isStepActive.general" circle>
            <font-awesome-icon icon="file-alt" />
          </el-button>
          <div>{{$t('general')}}</div>
        </a>
      </div>
      <div class="step-contract" :class="isStepActive.agent">
        <a @click="showContractContainer('agent')">
          <el-button :type="isStepActive.agent" circle>
            <font-awesome-icon icon="user-alt" />
          </el-button>
          <div>{{$t('agent')}}</div>
        </a>
      </div>
      <div class="step-contract" :class="isStepActive.rateCode">
        <a @click="showContractContainer('rateCode')">
          <el-button :type="isStepActive.rateCode" circle>
            <font-awesome-icon icon="coins" />
          </el-button>
          <div>{{$t('rateCode')}}</div>
        </a>
      </div>
      <div class="step-contract" :class="isStepActive.allotment">
        <a @click="showContractContainer('allotment')">
          <el-button :type="isStepActive.allotment" circle>
            <font-awesome-icon icon="th-large" />
          </el-button>
          <div>{{$t('allotment')}}</div>
        </a>
      </div>
      <div class="step-contract" :class="isStepActive.promotion">
        <a @click="showContractContainer('promotion')">
          <el-button :type="isStepActive.promotion" circle>
            <font-awesome-icon icon="star" />
          </el-button>
          <div>{{$t('promotion')}}</div>
        </a>
      </div>
      <div class="step-contract" :class="isStepActive.supplement">
        <a @click="showContractContainer('supplement')">
          <el-button :type="isStepActive.supplement" circle>
            <font-awesome-icon icon="comment-dollar" />
          </el-button>
          <div>{{$t('supplement')}}</div>
        </a>
      </div>
      <div class="step-contract" :class="isStepActive.transfer">
        <a @click="showContractContainer('transfer')">
          <el-button :type="isStepActive.transfer" circle>
            <font-awesome-icon icon="car-alt" />
          </el-button>
          <div>{{$t('transfer')}}</div>
        </a>
      </div>
      <div class="step-contract" :class="isStepActive.termsOfPayment">
        <a @click="showContractContainer('termsOfPayment')">
          <el-button :type="isStepActive.termsOfPayment" circle>
            <font-awesome-icon icon="credit-card" />
          </el-button>
          <div>{{$t('termsOfPayment')}}</div>
        </a>
      </div>
    </div>
    <el-button
      v-if="currentTab !== 'general'"
      type="primary"
      class="prev-tab tab-action"
      @click="onClickChangeTabContract(PREV)">
      <i class="el-icon-arrow-left"></i>
    </el-button>
    <el-button
      v-if="currentTab !== 'termsOfPayment'"
      type="primary"
      class="next-tab tab-action"
      @click="onClickChangeTabContract(NEXT)">
      <i class="el-icon-arrow-right"></i>
    </el-button>
  </el-row>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import i18nMessages from '@/translations/Contract/components/ContractMenu.i18n'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFileAlt, faUserAlt, faCoins, faStar, faThLarge, faCommentDollar, faCarAlt, faCreditCard } from '@fortawesome/free-solid-svg-icons'

const TAB_KEY_LIST = ['general', 'agent', 'rateCode', 'allotment', 'promotion', 'supplement', 'transfer', 'termsOfPayment']
const PREV = -1
const NEXT = 1

library.add(faFileAlt, faUserAlt, faCoins, faThLarge, faStar, faCommentDollar, faCarAlt, faCreditCard)

export default {
  name: 'ContractMenu',
  i18n: { messages: i18nMessages },
  components: { FontAwesomeIcon },
  created: function () {},
  data () {
    return {
      PREV,
      NEXT,
      isStepActive: {
        general: 'primary',
        agent: '',
        rateCode: '',
        allotment: '',
        promotion: '',
        supplement: '',
        transfer: '',
        termsOfPayment: ''
      },
      isShowContainer: {
        general: true,
        agent: false,
        rateCode: false,
        allotment: false,
        promotion: false,
        supplement: false,
        transfer: false,
        termsOfPayment: false
      },
      currentTab: TAB_KEY_LIST[0]
    }
  },
  methods: {
    showContractContainer: function (containerName) {
      for (let name in this.isShowContainer) {
        this.isShowContainer[name] = false
        this.isStepActive[name] = ''
      }

      this.isShowContainer[containerName] = true
      this.isStepActive[containerName] = 'primary'
      this.currentTab = containerName

      this.$emit('onClickContractMenu', this.isShowContainer)
    },
    onClickChangeTabContract: function (step) {
      const currentTabIndex = TAB_KEY_LIST.indexOf(this.currentTab)
      const tabName = TAB_KEY_LIST[currentTabIndex + step]
      this.showContractContainer(tabName)
    }
  }
}
</script>

<style scoped>
  .step-contract {
    list-style: none;
    float: left;
    text-align: center;
    width: calc(100% / 8);
    font-weight: bold;
    font-size: 15px;
    position: relative;
  }
  .step-contract > a > div {
    margin-top: 5px;
    cursor: pointer;
  }

  .tab-action {
    position: relative;
    border-radius: 0;
    width: 40px;
    height: 60px;
    top: -70px;
  }
  .next-tab {
    right: 0px;
    top: calc(97px + (50% - 78.5px));
    position: absolute;
    z-index: 1;
  }
  .next-tab i {
    font-size: 30px;
    right: 15px;
    position: relative;
  }
  .prev-tab {
    left: 0px;
    top: calc(97px + (50% - 78.5px));
    position: absolute;
    z-index: 1;
  }
  .prev-tab i {
    font-size: 30px;
    left: -15px;
    position: relative;
  }
  .el-button.is-circle {
    width: 42px;
    height: 42px;
  }
  .step-contract::before {
    content: '';
    border-bottom: 4px solid #DBDBDB;
    width: calc(100% - 42px);
    display: block;
    position: absolute;
    margin-left: 1px;
    margin-top: -2px;
    top: 21px;
    right: calc(50% + 21px);
  }

  .step-contract.primary::before {
    border-bottom: 4px solid #409EFF;
  }

  .step-contract.hide-line::before {
    display: none !important;
  }
</style>
